import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-gray-900 py-8">
      <div className="container mx-auto px-4 text-center space-y-3">
        <div className="flex items-center justify-center gap-3 text-sm text-gray-400">
          <Link href="/terms" className="hover:text-gray-300 transition-colors">
            이용약관
          </Link>
          <span className="text-gray-600">|</span>
          <Link href="/privacy" className="hover:text-gray-300 transition-colors">
            개인정보 처리방침
          </Link>
        </div>
        <p className="text-sm text-gray-500">
          © 2026 Refleco. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
